import React from "react";
import { Field } from "react-final-form";
import { TextFieldAdapter } from "@soqs/common";
const FraudEmailFieldComponent = (props) => {
  let { required, name, label } = props;

  if (required === undefined) {
    required = false;
  }
  if (name === undefined) {
    name = "email";
  }
  if (label === undefined) {
    label = "Email";
  }

  const isValid = (tel) => {
    const re =
      // eslint-disable-next-line no-control-regex
      /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

    return (tel || !required) &&
      (re.test(tel?.toLowerCase()) ||
        (!required && (tel === undefined || tel?.length === 0)))
      ? undefined
      : " Please supply a valid " + label + " address";
  };

  return (
    <Field
      name={name}
      validate={isValid}
      label={label}
      required={required}
      component={TextFieldAdapter}
      subscription={{
        touched: true,
        value: true,
        error: true,
        pristine: true,
        required: true,
      }}
      fullWidth
      inputProps={{ maxLength: 50 }}
    />
  );
};

export default FraudEmailFieldComponent;
